import axios from 'axios'
import swal from 'sweetalert'
export default{
    methods:{
        eliminarBitacora(id){
        swal({
            title:'Seguro que deseas eliminar el registro',
            text:'Al eliminarlo no podrás recuperarlo',
            icon:'warning',
            buttons:true,
            dangerMode:true,
        })
        .then((aceptar)=>{
            if(aceptar){
        
                axios.get('https://micomidasegura.mx/comidaSegura/api/crud/eliminarBitacora.php?id=' + id)
            .then(res =>{
                if(res.data=='success'){
                   swal('Registro eliminado')
                    return true;
                }else{
                    swal('Registro no eliminado')
                   return false;
                }
            })
            }else{
                return false;
            }
        })
    }
}
}


// WEBPACK FOOTER //
// ./src/mixins/eliminarBitacora.js